const formatDate = date => {
  var date = date === undefined ? new Date() : new Date(date)
  var dd = date.getUTCDate()
  var mm = date.getMonth() + 1
  var yyyy = date.getFullYear()
  if (dd < 10) dd = '0' + dd
  if (mm < 10) mm = '0' + mm

  return yyyy + '-' + mm + '-' + dd
}

const formatRealDate = date => {
  var date = date === undefined ? new Date() : new Date(date)

  var dd = date.getDate()
  var mm = date.getMonth() + 1
  var yyyy = date.getFullYear()
  if (dd < 10) dd = '0' + dd
  if (mm < 10) mm = '0' + mm

  return yyyy + '-' + mm + '-' + dd
}

const getPeriod = (periodList, orderDate, cb) => {
  for (let i = 0; i < periodList.length; i++) {
    let d1Ms = new Date(periodList[i].from).getTime()
    let d2Ms = new Date(periodList[i].to).getTime()
    let d3Ms = new Date(orderDate).getTime()
    if (d3Ms >= d1Ms && d3Ms <= d2Ms) {
      return periodList[i]
    }
  }
  return cb(orderDate)
}
const daysBetween = (date1, date2) => {
  // Convert both dates to milliseconds
  let date1Ms = new Date(date1).getTime()
  let date2Ms = new Date(date2).getTime()
  let differenceMs = date2Ms - date1Ms
  let sec = differenceMs / 1000
  if (sec < 3599) {
    return parseInt(sec / 60) + 'm'
  } else if (sec < 86399) {
    return parseInt(sec / 60 / 60) + 'h'
  } else {
    return Math.ceil(sec / 60 / 60 / 24) + 'd'
  }
}

const todayMinusXDays = num => {
  var from = new Date()
  return formatDate(new Date(from.setDate(from.getDate() - num)))
}

// Returns today minus X month
// if today is day 31 it will return last day of the month
var todayMinusXMonths = (num, date) => {
  var from = date === null || date === undefined ? new Date() : new Date(date)
  var fromMinusNumMonths = new Date(from.getTime())
  fromMinusNumMonths.setMonth(fromMinusNumMonths.getMonth() - num)
  if (fromMinusNumMonths.getDate() < from.getDate()) {
    return formatRealDate(new Date(fromMinusNumMonths.getFullYear(), fromMinusNumMonths.getMonth() - 1, 0))
  } else {
    return formatRealDate(fromMinusNumMonths.setHours(24))
  }
}

const currentDay = () => {
  return formatDate(new Date())
}

const currentMonth = () => {
  return pad(new Date().getMonth() + 1, 2)
}

const firstDayOfCurrentMonth = () => {
  let today = new Date()
  return formatDate(new Date(today.getFullYear(), today.getMonth(), 1))
}

const firstDayOfCurrentMonthMinusXMonths = num => {
  let today = new Date()
  return formatDate(new Date(today.getFullYear(), today.getMonth() - num, 1))
}

const lastDayOfLastMonthMinusXMonths = num => {
  let today = new Date()
  let date = new Date(today.getFullYear(), today.getMonth() - num, 1)
  return formatDate(new Date(date.setDate(date.getDate() - 1)))
}

const getDateRange = (first, last) => {
  let firstDate = first.splitDate || { day: '01', month: '01', year: '2019' }
  let lastDate = last.splitDate || { day: '01', month: '01', year: '2019' }
  let formattedFirstDate = new Date(
    `${firstDate.year}-${firstDate.month}-${firstDate.day}`
  )
  let formattedLastDate = new Date(
    `${lastDate.year}-${lastDate.month}-${lastDate.day}`
  )
  let from = formatRealDate(
    new Date(formattedFirstDate.getFullYear(), formattedFirstDate.getMonth(), 0)
  )
  let to = formatRealDate(
    new Date(
      formattedLastDate.getFullYear(),
      formattedLastDate.getMonth() + 1,
      0
    )
  )
  return {
    from: from + ' 00:00:00',
    to: to + ' 23:59:59'
  }
}

const splitDate = dateStr => {
  const dateWithoutHours = dateStr.substring(0, 10)
  const dateSplit = dateWithoutHours.split('-')
  return {
    year: dateSplit[0],
    month: dateSplit[1],
    day: dateSplit[2]
  }
}
const pad = (num, size) => {
  var s = num + ''
  while (s.length < size) s = '0' + s
  return s
}

const lastday = function (y, m) {
  return new Date(y, m, 0).getDate()
}

const getDateArray = function (start, end) {
  let arr = []
  let dt = new Date(start)
  while (dt >= end) {
    let i = dt.getMonth() + 1
    arr.push({
      code: pad(i, 2),
      year: dt.getFullYear(),
      title: 'month.' + i,
      from: dt.getFullYear() + '-' + pad(i, 2) + '-01',
      to:
        dt.getFullYear() + '-' + pad(i, 2) + '-' + lastday(dt.getFullYear(), i),
      vsFrom: dt.getFullYear() + '-' + pad(i, 2) + '-01',
      vsTo:
        dt.getFullYear() + '-' + pad(i, 2) + '-' + lastday(dt.getFullYear(), i)
    })
    dt.setMonth(dt.getMonth() - 1)
  }
  return arr
}

const getCommissionDateRange = () => {
  let lastDate = new Date(process.env.VUE_APP_COMMISSION_FROM_DATE)
  let startDate = new Date()
  let finalDate = getDateArray(startDate, lastDate)
  finalDate
    .sort(function (a, b) {
      return a.from - b.from
    })
    .map(obj => {
      if (obj.title === `month.${startDate.getMonth() + 1}`) {
        obj.title = 'commissions.interval.this_month'
        obj.year = ''
      }
      return obj
    })
  return finalDate
}

const checkAgreementDate = (from, agreementDate) => {
  if (agreementDate < from) return 'valid'
  else if (agreementDate > from || from === agreementDate) { return 'agreementDate' } else return 'invalid'
}

const dateToUTC = value => {
  let date = value ? new Date(value) : new Date()
  return new Date(date.getTime() + date.getTimezoneOffset() * 60000)
}

export {
  formatDate,
  formatRealDate,
  todayMinusXDays,
  todayMinusXMonths,
  currentDay,
  currentMonth,
  getPeriod,
  lastday,
  firstDayOfCurrentMonth,
  firstDayOfCurrentMonthMinusXMonths,
  lastDayOfLastMonthMinusXMonths,
  splitDate,
  getDateRange,
  daysBetween,
  pad,
  getCommissionDateRange,
  checkAgreementDate,
  dateToUTC
}
